import { Dispatch } from "redux";
import { createUserRequest } from "@requests/axnadmin-core";
import { AxnAdminUserPropertyBundle } from "@idw-types/data/axn-admin-user-property-bundle";
import { AxnCompany, AxnIdentityProvider, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { RpUserPropertyBundle } from "@idw-types/data/axn-admin-user/rp-user-property-bundle";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { RelyingPartyRole } from "@idw-types/common";
import { getOrganizationUsersReduxRequest } from "@redux-requests/organization-users/get-organization-users";
import { getOrganizationInvitationsReduxRequest } from "@redux-requests/organization-invitations";
import { AxnAdminAvailableUserProperty } from "@idw-types/data/axn-admin-available-user-property";

export const createUserReduxRequest = (dispatch: Dispatch) => async (
    firstName: string,
    lastName: string,
    email: string,
    credential: string,
    apiUserName: string,
    apiPassword: string,
    axnCompany: AxnCompany,
    identityProviderId: string,
    organizationRole: AxnAdminUserPropertyBundle,
    relyingPartyRoles: Array<RelyingPartyRole>,
    shouldReloadUsers: boolean,
    shouldReloadInvitations: boolean,
    axnCompanies: Array<AxnCompany>,
    axnIdentityProviders: Array<AxnIdentityProvider>,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnRelyingParties: Array<AxnRelyingParty>,
    axnAdminAvailableUserOrganizationProperties: Array<AxnAdminAvailableUserProperty>,
    axnAdminAvailableUserRPProperties: Array<AxnAdminAvailableUserProperty>
) => {

    const rpUserPropertyBundles: Array<RpUserPropertyBundle> = relyingPartyRoles.map(rpr => ({
        relyingPartyID: parseInt(rpr.relyingParty.id),
        userPropertyBundleID: parseInt(rpr.bundle.id)
    }));

    const { data, error, body } = await createUserRequest(
        firstName,
        lastName,
        email,
        credential,
        apiUserName,
        apiPassword,
        axnCompany.id,
        identityProviderId,
        organizationRole?.id,
        rpUserPropertyBundles
    );

    if (data) {
        displaySuccessModal(
            dispatch,
            resources.requests.createUser.success.title,
            resources.requests.createUser.success.message
        );
        if (shouldReloadUsers) {
            await getOrganizationUsersReduxRequest(dispatch)(
                axnCompanies,
                axnIdentityProviders,
                axnAdminUserPropertyBundles,
                axnAdminAvailableUserOrganizationProperties,
                axnAdminAvailableUserRPProperties,
                axnRelyingParties);
        }
        if (shouldReloadInvitations) {
            await getOrganizationInvitationsReduxRequest(dispatch)(axnAdminUserPropertyBundles, axnCompanies, axnRelyingParties);
        }
        return data;
    }
    else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createUser.error.title,
            resources.requests.createUser.error.message,
            error,
            null,
            body
        );
    }

    return null;
};